export default __webpack_public_path__ + "static/media/Birthday.f1d85653.svg";